'use client'
import { PublicHeader } from '@/components/public/PublicHeader'
import { Footer } from '@/components/public/Footer'
import { RegistrationForm } from '@/components/public/RegistrationForm'
import { FileText } from 'lucide-react'
import { useLanguage } from '@/lib/language-context'

export default function RegistrationPage() {
  const { t } = useLanguage()

  return (
    <div className="min-h-screen flex flex-col" style={{ background: '#1a0d04' }}>
      <PublicHeader />
      <main className="flex-1 py-16 px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <div
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '8px',
                background: 'rgba(243,156,18,0.1)', border: '1px solid rgba(243,156,18,0.3)',
                borderRadius: '100px', padding: '6px 18px', marginBottom: '16px',
              }}
            >
              <FileText className="w-4 h-4" style={{ color: '#F39C12' }} />
              <span style={{ color: '#F39C12', fontSize: '0.85rem', fontWeight: 600 }}>Citizen Registration</span>
            </div>
            <h2 style={{ fontFamily: 'Poppins, sans-serif', fontWeight: 800, fontSize: '2.2rem', color: '#ffffff', marginBottom: '8px' }}>
              {t('citizenRegForm')}
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '1rem' }}>{t('fillDetails')}</p>
            <div style={{ width: '60px', height: '3px', background: 'linear-gradient(90deg, #F39C12, #E67E22)', borderRadius: '100px', margin: '16px auto 0' }} />
          </div>
          <RegistrationForm />
        </div>
      </main>
      <Footer />
    </div>
  )
}
